import React, { useEffect, useRef, useState } from "react";
import { CheckCircle2, X } from "lucide-react";

import ListaSugestoes from "./ListaSugestoes";

const TEMPO_MS = 9000;

// Logo após adicionar: "Combina com o seu X". Some sozinho, fecha no X ou ao tocar numa sugestão.
export default function CombinaCom({ adicionado, itens, onEscolher, onFechar, precoDe, fotoDe, darkMode }) {
  const [pausado, setPausado] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (!adicionado || pausado || !itens.length) return undefined;
    timer.current = setTimeout(onFechar, TEMPO_MS);
    return () => clearTimeout(timer.current);
  }, [adicionado, pausado, itens.length, onFechar]);
  if (!adicionado || !itens.length) return null;
  return (
    <div className="fixed left-0 right-0 bottom-[64px] z-30 px-3 pointer-events-none" data-e2e="combina-com">
      <div onPointerDown={() => setPausado(true)}
        className={`pointer-events-auto max-w-[480px] mx-auto rounded-2xl border shadow-2xl p-3 animate-in slide-in-from-bottom-4 fade-in duration-300 ${darkMode ? "bg-zinc-900 border-zinc-700" : "bg-white border-gray-200"}`}>
        <div className="flex items-start gap-2 mb-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className={`text-xs ${darkMode ? "text-zinc-400" : "text-gray-500"}`}>{adicionado.nome} na sacola</p>
            <p className={`text-sm font-bold leading-tight ${darkMode ? "text-white" : "text-gray-900"}`}>Combina com o seu {adicionado.nome}</p>
          </div>
          <button type="button" onClick={onFechar} aria-label="Fechar sugestões" className={`p-1 rounded-full ${darkMode ? "hover:bg-zinc-800 text-zinc-400" : "hover:bg-gray-100 text-gray-500"}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
        <ListaSugestoes lugar="adicionado" itens={itens} onEscolher={onEscolher} precoDe={precoDe} fotoDe={fotoDe} darkMode={darkMode} compacto />
      </div>
    </div>
  );
}
